// CCX-610
import { useEffect } from 'react';

import { NEW_CHECKOUT_PAGE } from 'config/Urls.config';
import { goToCartHandler } from 'pages/Cart/helpers/url.helpers';
import { MAF_CHECKOUT_REFERRER_URI } from '../../Cart/constants/cart.constants';
import useCartRevampEnabled from 'hooks/useCartRevampEnabled';

const useReferrerUri = (currentPage?: string) => {
  const isCartRevampEnabled = useCartRevampEnabled();
  useEffect(() => {
    // Will not work if user has accessed the page directly
    // history.goBack();

    // Save referrer URI if `referrerUri` is cart URL and not equal to checkout URL
    const referrerUri = document.referrer || currentPage;
    const isCartUri = referrerUri && referrerUri.indexOf('/cart') !== -1;
    if (
      referrerUri &&
      isCartUri &&
      referrerUri.indexOf('/update') === -1 &&
      referrerUri.indexOf(NEW_CHECKOUT_PAGE) === -1
    ) {
      window.sessionStorage.setItem(MAF_CHECKOUT_REFERRER_URI, referrerUri);
    }
  }, [currentPage]);

  const onBackToCartHandler = () => {
    goToCartHandler(isCartRevampEnabled);
  };

  return [onBackToCartHandler];
};

export default useReferrerUri;
